module.exports = __webpack_public_path__ + "DanieMahaffey.webp?a6bff3d8c98148e886a0dd7f711f62c6";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/DanieMahaffey.webp
// module id = 72
// module chunks = 0